import { webToCatchFaceConnect } from 'src/features/atoms/glove/drawer/rightThrow/glove/back/lace/webToCatchFaceConnect'
import { webKnots } from 'src/features/atoms/glove/drawer/common/back/lace/webKnots'
import { middleSidePartOfWeb, topSidePartOfWeb, topSidePartOfWebWithJoint } from './parts/sideParts'
import { drawWithImagePatternWrapper } from 'src/util/canvasImagePattern'

export const hWeb2 = async (
  ctx: CanvasRenderingContext2D,
  laceColor: string,
  stitchColor: string,
  webColor: string,
  webColor2: string,
  printLeatherTypeValue?: string
): Promise<void> => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // 横上パーツ
  await topSidePartOfWeb(ctx, webColor, laceColor, stitchColor, printLeatherTypeValue)
  // 横下パーツ
  await middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -10, 10, 1, 1, printLeatherTypeValue)

  // 縦パーツ
  ctx.strokeStyle = '#282828'
  const drawPath = () => {
    ctx.beginPath()
    ctx.moveTo(587, 77) //左上＿左上
    ctx.quadraticCurveTo(567, 107, 567, 107) //左上＿左下
    ctx.quadraticCurveTo(580, 157, 580, 157) //中央＿左
    ctx.quadraticCurveTo(550, 153, 550, 153) //左下＿左上
    ctx.quadraticCurveTo(530, 181, 530, 181) //左下＿左下
    ctx.quadraticCurveTo(549, 193, 569, 216) //左下＿右下
    ctx.quadraticCurveTo(577, 208, 577, 208) //左下＿右上
    ctx.quadraticCurveTo(610, 207, 610, 207) //中央＿下
    ctx.quadraticCurveTo(607, 248, 607, 248) //右下＿左上
    ctx.quadraticCurveTo(599, 259, 599, 259) //右下＿左下
    ctx.quadraticCurveTo(614, 288, 619, 314) //右下＿右下
    ctx.quadraticCurveTo(645, 281, 645, 281) //右下＿右上
    ctx.quadraticCurveTo(646, 231, 646, 231) //中央＿右
    ctx.quadraticCurveTo(667, 255, 667, 255) //右上＿右下
    ctx.quadraticCurveTo(696, 236, 696, 236) //右上＿右上
    ctx.quadraticCurveTo(684, 202, 668, 176) //右上＿左上
    ctx.quadraticCurveTo(650, 193, 650, 193) //右上＿左下
    ctx.quadraticCurveTo(621, 188, 621, 188) //中央＿上
    ctx.quadraticCurveTo(620, 145, 620, 145) //左上＿右下
    ctx.quadraticCurveTo(636, 125, 636, 125) //左上＿右上
    ctx.quadraticCurveTo(615, 97, 587, 77) //左上＿左上
    ctx.fill()
    ctx.stroke()
    ctx.closePath()
  }

  await drawWithImagePatternWrapper(ctx, printLeatherTypeValue, drawPath, webColor2)

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 左辺
  ctx.moveTo(589, 81) // 左上＿左上
  ctx.quadraticCurveTo(571, 108, 571, 108) // 左上＿左下
  ctx.quadraticCurveTo(583, 157, 585, 160) // 中央左
  ctx.quadraticCurveTo(551, 157, 551, 157) // 左下＿左上
  ctx.quadraticCurveTo(535, 179, 535, 179) // 左下＿左下
  // // 下辺
  ctx.moveTo(569, 212) // 左下＿右下
  ctx.quadraticCurveTo(576, 204, 576, 204) // 左下＿右上
  ctx.quadraticCurveTo(613, 204, 613, 204) // 中央＿上
  ctx.quadraticCurveTo(610, 249, 610, 249) // 右下＿左上
  ctx.quadraticCurveTo(601, 260, 601, 260) // 右下＿左下
  // // 右辺
  ctx.moveTo(620, 308) // 右下＿右下
  ctx.quadraticCurveTo(642, 279, 642, 279) // 右下＿右上
  ctx.quadraticCurveTo(644, 224, 644, 224) // 中央＿右
  ctx.quadraticCurveTo(667, 250, 667, 250) // 左上＿右下
  ctx.quadraticCurveTo(693, 233, 693, 233) // 左上＿右上
  // // 上辺
  ctx.moveTo(668, 180) // 上
  ctx.quadraticCurveTo(652, 196, 652, 196) // 下
  ctx.quadraticCurveTo(618, 191, 618, 191) // 下
  ctx.quadraticCurveTo(617, 144, 617, 144) // 下
  ctx.quadraticCurveTo(633, 123, 633, 123) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, -55, 45) // 捕球面寄りのウェブ結び目
  // 左上
  ctx.beginPath()
  ctx.moveTo(591, 105) // 左上
  ctx.quadraticCurveTo(589, 131, 600, 163) //左下
  ctx.quadraticCurveTo(604, 164, 608, 160) //右下
  ctx.quadraticCurveTo(602, 129, 602, 102) //右上
  ctx.quadraticCurveTo(595, 97, 591, 105) //右上
  ctx.fill()
  ctx.moveTo(600, 101) // 右上
  ctx.quadraticCurveTo(600, 122, 606, 160) //右下
  ctx.stroke()
  ctx.closePath()

  // 左下
  ctx.beginPath()
  ctx.moveTo(557, 181) // 左上
  ctx.quadraticCurveTo(554, 185, 559, 188) //左下
  ctx.quadraticCurveTo(570, 180, 601, 185) //右下
  ctx.quadraticCurveTo(605, 180, 604, 177) //右上
  ctx.quadraticCurveTo(570, 171, 557, 181) //左上
  ctx.fill()
  ctx.moveTo(558, 187) // 左
  ctx.quadraticCurveTo(573, 177, 601, 183) //右
  ctx.stroke()
  ctx.closePath()

  // 右上
  ctx.beginPath()
  ctx.moveTo(635, 201) // 左上
  ctx.quadraticCurveTo(634, 208, 634, 208) //左下
  ctx.quadraticCurveTo(675, 220, 675, 220) //右下
  ctx.quadraticCurveTo(679, 213, 674, 212) //右上
  ctx.quadraticCurveTo(655, 200, 635, 201) //左上
  ctx.fill()
  ctx.moveTo(634, 208) //左下
  ctx.quadraticCurveTo(653, 209, 675, 220) //右下
  ctx.stroke()
  ctx.closePath()

  // 右下
  ctx.beginPath()
  ctx.moveTo(623, 214) // 左上
  ctx.quadraticCurveTo(618, 265, 621, 268) //左下
  ctx.quadraticCurveTo(620, 269, 629, 271) //右下
  ctx.quadraticCurveTo(632, 217, 632, 217) //右上
  ctx.quadraticCurveTo(628, 211, 623, 214) //左上
  ctx.fill()
  ctx.moveTo(632, 217) // 上
  ctx.quadraticCurveTo(627, 239, 629, 271) //下
  ctx.stroke()
  ctx.closePath()
}

export const hJointWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  const webColor2 = webColor
  // 横上パーツ
  topSidePartOfWebWithJoint(ctx, webColor, webColor2, laceColor, stitchColor)
  // 横下パーツ
  middleSidePartOfWeb(ctx, webColor, laceColor, stitchColor, -17, 18, 1, 1)
  // 縦パーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(610, 160) //左上
  ctx.quadraticCurveTo(607, 176, 563, 226) //左下
  ctx.quadraticCurveTo(585, 250, 599, 283) //右下
  ctx.quadraticCurveTo(633, 254, 648, 225) //右上
  ctx.quadraticCurveTo(635, 186, 610, 160) //左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // // 縦向き＿左＿外側
  ctx.moveTo(612, 167) // 上
  ctx.quadraticCurveTo(601, 194, 576, 220) // 下
  // // // 縦向き＿左＿内側
  ctx.moveTo(614, 170) // 上
  ctx.quadraticCurveTo(605, 195, 580, 222) // 下
  // // // 縦向き＿右＿内側
  ctx.moveTo(642, 220) // 上
  ctx.quadraticCurveTo(629, 247, 606, 269) // 下
  // // // 縦向き＿右＿外側
  ctx.moveTo(644, 224) // 上
  ctx.quadraticCurveTo(633, 249, 608, 273) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで

  // laceここから
  webToCatchFaceConnect(ctx, laceColor, -35, 15)
  webKnots(ctx, laceColor, 5, -15) // ウェブ先端寄りのウェブ結び目
  webKnots(ctx, laceColor, -30, 30) // 捕球面寄りのウェブ結び目
}
